module.exports = __webpack_public_path__ + "img/how-might-mobile.1897ee0d.svg";